import EditorMonetizationOnIcon from '@mui/icons-material/MonetizationOn';

import PaymentList from './PaymentList';

export default {
      list: PaymentList,
      icon: EditorMonetizationOnIcon,
}